import { createInMemoryAtom } from '@exodus/atoms';
import type { Definition } from '@exodus/dependency-types';

const createAnalyticsExtraSeedsUserIdsAtom = () =>
  createInMemoryAtom({
    defaultValue: {},
  });

const analyticsExtraSeedsUserIdsAtomDefinition = {
  id: 'analyticsExtraSeedsUserIdsAtom',
  type: 'atom',
  factory: createAnalyticsExtraSeedsUserIdsAtom,
  override: true,
} as const satisfies Definition;

export default analyticsExtraSeedsUserIdsAtomDefinition;
